<div class="header">
  <div class="title">
    <div class="breadcrumb">
      <span class="path"><a [routerLink]="['../']">PDF Reports</a><span class="separator">/</span>Edit</span>
    </div>
    <h1 class="mt-1">{{ reportLayout.name }}</h1>
  </div>
  <div class="main-actions">
    <ts-button
      [appAuthorize]="reportLayout.permissions?.is_editable"
      denyAction="disable"
      icon="ts_save"
      variant="primary"
      [disabled]="!isFormValid"
      (click)="save()"
    >
      Save
    </ts-button>
    <ts-button
      class="add-contact ml-2"
      variant="primary"
      icon="keyboard_arrow_down"
      denyAction="disable"
      [loading]="runningReport"
      [appAuthorize]="NewPermission.PDF_REPORTS_SHARING_RECORDS"
      [matMenuTriggerFor]="addProjectMenu"
      [disabled]="modifiedWithoutSave"
    >
      Download Report
    </ts-button>
    <mat-menu #addProjectMenu="matMenu">
      <button mat-menu-item (click)="runReport('pdf')">
        <span class="ml-2"><mat-icon [svgIcon]="'picture_as_pdf'"></mat-icon> Download PDF</span>
      </button>
      <button mat-menu-item (click)="runReport('csv')">
        <span class="ml-2"><mat-icon [svgIcon]="'save_alt'"></mat-icon> Download CSV</span>
      </button>
    </mat-menu>
    <button class="more-menu" mat-icon-button [matMenuTriggerFor]="moreMenu" [appAuthorize]="canShowThreeDotMenu()">
      <mat-icon [svgIcon]="'more_vert'"></mat-icon>
    </button>
    <mat-menu #moreMenu="matMenu">
      <button
        [appAuthorize]="NewPermission.PDF_REPORTS_CREATE"
        denyAction="hide"
        mat-menu-item
        (click)="duplicateReportLayout()"
      >
        <mat-icon [svgIcon]="'file_copy'"></mat-icon>
        <span>Duplicate</span>
      </button>
      <button
        [appAuthorize]="reportLayout.permissions?.is_deletable"
        denyAction="disable"
        mat-menu-item
        (click)="deleteReportLayout()"
      >
        <mat-icon [svgIcon]="'delete'"></mat-icon>
        <span>Delete</span>
      </button>
    </mat-menu>
  </div>
</div>

<!-- Report Name -->
<form class="general-form flex flex-row" [formGroup]="reportLayoutForm">
  <div class="flex flex-col w-1/2 my-4 px-8 py-10 mr-2 bg-card shadow rounded overflow-hidden">
    <p class="text-lg font-medium">Report Name</p>
    <p class="text-secondary">Set the name of the report</p>
    <mat-divider
      role="separator"
      class="mat-divider mt-8 mb-10 mat-divider-horizontal"
      aria-orientation="horizontal"
    ></mat-divider>
    <div class="flex-auto min-w-64">
      <div class="flex flex-col gt-xs:flex-row mt-3">
        <mat-form-field class="subject flex-auto">
          <mat-label>Report Name</mat-label>
          <input matInput [formControlName]="'name'" />
        </mat-form-field>
      </div>
      <div class="flex flex-col gt-xs:flex-row mt-3">
        <mat-form-field class="treo-mat-textarea treo-mat-no-subscript flex-auto">
          <mat-label>Description</mat-label>
          <textarea matInput treoAutogrow [formControlName]="'description'" [spellcheck]="false"></textarea>
        </mat-form-field>
      </div>
    </div>
  </div>
  <!-- BEGIN CONFIGURATIONS -->
  <div class="flex flex-col w-1/2 my-4 px-8 py-10 bg-card shadow rounded overflow-hidden">
    <p class="text-lg font-medium">Configurations</p>
    <p class="text-secondary">Set the report's header alignment, columns color and report logo</p>
    <mat-divider
      role="separator"
      class="mat-divider mt-8 mb-8 mat-divider-horizontal"
      aria-orientation="horizontal"
    ></mat-divider>

    <!-- BEGIN HEADER ALIGNMENT -->
    <mat-form-field class="mt-3">
      <mat-label>Horizontal alignment (defaults to center)</mat-label>
      <mat-select [formControlName]="'header_alignment'">
        <mat-option *ngFor="let positionValues of headerAlignmentValues" [value]="positionValues">
          {{ positionValues | titlecase }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <!-- END HEADER ALIGNMENT -->

    <!-- BEGIN COLUMN COLORS -->
    <mat-form-field class="mt-3 w-1/3">
      <mat-label>Choose the columns color</mat-label>
      <mat-icon #cpIcon [svgIcon]="'color_lens'"></mat-icon>
      <input
        matInput
        readonly
        [formControlName]="'column_color'"
        class="rounded-color-display"
        [style.background]="reportLayout.column_color"
        [(colorPicker)]="reportLayout.column_color"
        [cpPosition]="colorPickerOptions.cpPosition"
        [(cpToggle)]="colorPickerOptions.cpToggle"
        (colorPickerChange)="onChangeColor($event)"
      />
    </mat-form-field>
    <!-- END COLUMN COLORS -->

    <!-- BEGIN UPLOAD COMPANY LOGO -->
    <section class="company-logo">
      <article class="company-logo__wrapper">
        <section class="upload">
          <input
            #logoFileInput
            id="company-logo-file-input"
            type="file"
            [multiple]="false"
            [accept]="'image/jpeg, image/png'"
            (change)="uploadCompanyLogo(logoFileInput.files)"
          />
          <label for="company-logo-file-input" matRipple>
            <mat-icon
              [appAuthorize]="reportLayout.permissions?.is_editable"
              denyAction="disable"
              [svgIcon]="'photo_camera'"
            ></mat-icon>
          </label>
        </section>
        <section class="remove">
          <button
            [appAuthorize]="reportLayout.permissions?.is_editable"
            denyAction="disable"
            mat-icon-button
            type="button"
            (click)="removeCompanyLogo()"
          >
            <mat-icon [svgIcon]="'delete'"></mat-icon>
          </button>
        </section>
        <ng-container *ngIf="reportLayout.logo_url; else NoCompanyLogo">
          <img [src]="reportLayout.logo_url" />
        </ng-container>
        <ng-template #NoCompanyLogo>
          <section class="no-logo">
            <p>No Logo</p>
          </section>
        </ng-template>
      </article>
    </section>
    <!-- END UPLOAD COMPANY LOGO -->
  </div>
  <!-- END CONFIGURATIONS -->
</form>

<!-- Filters -->
<form class="filters-form">
  <div class="flex flex-col my-4 px-8 py-10 bg-card shadow rounded overflow-hidden">
    <section class="flex justify-between">
      <article>
        <p class="text-lg font-medium">Filters</p>
        <p class="text-secondary">Select & save filters for this report</p>
      </article>
      <ts-button
        [disabled]="!this.reportLayout.permissions?.is_editable || !this.isFilterRowsValid"
        [matTooltip]="!this.reportLayout.permissions?.is_editable ? PERMISSION_DENY_LABEL : null"
        icon="ts_save"
        variant="primary"
        (click)="saveFilters()"
      >
        Save Filters
      </ts-button>
    </section>
    <mat-divider
      role="separator"
      class="mat-divider mt-8 mb-10 mat-divider-horizontal"
      aria-orientation="horizontal"
    ></mat-divider>
    <list-filter
      [readonly]="!hasPermissionToEditForm"
      (filterChanged)="filterChanged($event)"
      [queryFilters]="parsedFilters"
      (filterRowsValidityChange)="onFilterRowsValidityChange($event)"
      [savedFilter]="{}"
      [onlyList]="true"
      listStyle="width: 100%"
    ></list-filter>
  </div>
</form>

<!-- Table Report Layout -->
<div class="report-layout">
  <div class="flex flex-col my-4 px-8 py-10 bg-card shadow rounded overflow-hidden">
    <div class="flex flex-row justify-between">
      <div>
        <p class="text-lg font-medium">Table Report Layout</p>
        <p class="text-secondary">Define the table for the report</p>
      </div>
      <button
        [appAuthorize]="reportLayout.permissions?.is_editable"
        denyAction="disable"
        class="add-contact"
        mat-flat-button
        (click)="addPipelineField()"
      >
        <mat-icon [svgIcon]="'add'"></mat-icon>
        Add
      </button>
    </div>
    <mat-divider
      role="separator"
      class="mat-divider mt-8 mb-10 mat-divider-horizontal"
      aria-orientation="horizontal"
    ></mat-divider>
    <div class="report-layout__fields" cdkDropListGroup>
      <div class="report-layout__fields__container" *ngIf="hasReportFields; else noFieldsSetup">
        <div class="report-layout__fields__container__column-fixed">
          <p>Deal 2</p>
          <p>Deal 1</p>
        </div>
        <div
          cdkDropList
          [cdkDropListData]="fieldCol"
          (cdkDropListDropped)="dropped($event)"
          *ngFor="let fieldCol of parsedDefinition.pipeline.fields; let col = index"
          class="report-layout__fields__container__column"
        >
          <div class="report-layout__fields__container__column__rows">
            <div
              cdkDrag
              [cdkDragDisabled]="!hasPermissionToEditForm"
              *ngFor="let fieldName of fieldCol; let row = index"
              class="report-layout__fields__container__column__rows__row"
            >
              <ng-container *ngIf="lookupField(fieldName) as fieldDef">
                <mat-icon class="drag-handler" svgIcon="drag_indicator" matTooltip="Drag me" cdkDragHandle></mat-icon>
                <mat-form-field class="flex-auto gt-xs:pr-3">
                  <mat-select
                    [disabled]="!hasPermissionToEditForm"
                    [value]="fieldName"
                    (selectionChange)="onFieldSelectionChange($event, col, row)"
                  >
                    <mat-option value="">---</mat-option>
                    <mat-option *ngFor="let field of fieldDefs" [value]="field.name">{{ field.label }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-container>
            </div>
          </div>
          <div class="report-layout__fields__container__column__row-fixed">
            <div>
              <p>--</p>
              <p>--</p>
            </div>
            <div>
              <p>--</p>
              <p>--</p>
            </div>
          </div>
          <div class="report-layout__fields__container__column__actions">
            <button
              [appAuthorize]="reportLayout.permissions?.is_editable"
              denyAction="disable"
              mat-flat-button
              (click)="deleteReportColumn(col)"
              matTooltip="Remove"
            >
              <mat-icon svgIcon="delete"></mat-icon>
            </button>
          </div>
        </div>
      </div>
      <ng-template #noFieldsSetup><p class="report-layout__fields__no-data">No fields selected</p></ng-template>
    </div>
  </div>
</div>

<div class="flex flex-row min-w-64 other-options">
  <!-- Section Groupings -->
  <div class="flex flex-col w-1/3 my-4 px-8 py-10 mr-4 bg-card shadow rounded overflow-hidden">
    <div class="flex flex-row justify-between">
      <div>
        <p class="text-lg font-medium">Section Groupings</p>
      </div>
      <button
        [appAuthorize]="reportLayout.permissions?.is_editable"
        denyAction="disable"
        class="add-contact"
        mat-flat-button
        (click)="addGrouping()"
        *ngIf="parsedDefinition.pipeline.config.groupings.length < 3"
      >
        <mat-icon [svgIcon]="'add'"></mat-icon>
        Add
      </button>
    </div>
    <mat-divider
      role="separator"
      class="mat-divider mt-8 mb-10 mat-divider-horizontal"
      aria-orientation="horizontal"
    ></mat-divider>
    <div class="flex flex-col min-w-64">
      <ng-container *ngFor="let fieldName of parsedDefinition.pipeline.config.groupings; let index = index">
        <div class="flex flex-row">
          <ng-container>
            <mat-form-field class="flex-auto gt-xs:pr-3">
              <mat-label>{{ index + 1 }}. Group By</mat-label>
              <mat-select
                [disabled]="!hasPermissionToEditForm"
                [(ngModel)]="parsedDefinition.pipeline.config.groupings[index]"
                (selectionChange)="onSaveReport()"
              >
                <mat-option *ngFor="let field of fieldDefs" [value]="field.name">{{ field.label }}</mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>
          <button
            class="remove-email-field my-6"
            mat-icon-button
            *ngIf="index > 0"
            (click)="removeGrouping(index)"
            matTooltip="Remove"
          >
            <mat-icon [svgIcon]="'cancel'"></mat-icon>
          </button>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Sort Order -->
  <div class="flex flex-col w-1/3 my-4 px-8 py-10 mr-4 bg-card shadow rounded overflow-hidden">
    <div class="flex flex-row justify-between">
      <div>
        <p class="text-lg font-medium">Sort Order</p>
      </div>
      <button
        [appAuthorize]="reportLayout.permissions?.is_editable"
        denyAction="disable"
        class="add-contact"
        mat-flat-button
        (click)="addSortBy()"
        *ngIf="parsedDefinition.pipeline.config.sortings.length < 3"
      >
        <mat-icon [svgIcon]="'add'"></mat-icon>
        Add
      </button>
    </div>
    <mat-divider
      role="separator"
      class="mat-divider mt-8 mb-10 mat-divider-horizontal"
      aria-orientation="horizontal"
    ></mat-divider>
    <div class="flex flex-col min-w-64">
      <ng-container *ngFor="let sortBy of parsedDefinition.pipeline.config.sortings; let index = index">
        <div class="flex flex-row">
          <ng-container>
            <mat-form-field class="flex-auto gt-xs:pr-3">
              <mat-select
                [disabled]="!hasPermissionToEditForm"
                [(ngModel)]="parsedDefinition.pipeline.config.sortings[index].field"
                (selectionChange)="onSaveReport()"
              >
                <mat-option value="">---</mat-option>
                <mat-option *ngFor="let field of fieldDefs" [value]="field.name">{{ field.label }}</mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>
          <ng-container>
            <mat-form-field class="flex-auto gt-xs:pr-3">
              <mat-select
                [disabled]="!hasPermissionToEditForm"
                [(ngModel)]="parsedDefinition.pipeline.config.sortings[index].order"
                (selectionChange)="onSaveReport()"
              >
                <mat-option [value]="'asc'">Ascending (A-Z)</mat-option>
                <mat-option [value]="'desc'">Descending (Z-A)</mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>
          <button
            class="remove-email-field my-1"
            mat-icon-button
            *ngIf="index > 0"
            (click)="removeSorting(index)"
            matTooltip="Remove"
          >
            <mat-icon [svgIcon]="'cancel'"></mat-icon>
          </button>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Other -->
  <div class="flex flex-col w-1/3 my-4 px-8 py-10 bg-card shadow rounded overflow-hidden">
    <div class="flex flex-row justify-between">
      <div>
        <p class="text-lg font-medium">Other</p>
      </div>
    </div>
    <mat-divider
      role="separator"
      class="mat-divider mt-8 mb-10 mat-divider-horizontal"
      aria-orientation="horizontal"
    ></mat-divider>
    <div class="flex-row min-w-64">
      <mat-checkbox
        [disabled]="!hasPermissionToEditForm"
        [color]="'primary'"
        [(ngModel)]="parsedDefinition.pipeline.config.show_comments"
        (change)="onSaveReport()"
      >
        <span>Show Latest Comments with each deal</span>
      </mat-checkbox>
    </div>
    <div class="flex-row min-w-64 mt-5">
      <mat-checkbox
        [disabled]="!hasPermissionToEditForm"
        [color]="'primary'"
        [(ngModel)]="parsedDefinition.pipeline.config.show_description"
        (change)="onSaveReport()"
      >
        <span>Show description below each deal</span>
      </mat-checkbox>
    </div>
    <div class="flex-row min-w-64 mt-5">
      <mat-checkbox
        [disabled]="!hasPermissionToEditForm"
        [color]="'primary'"
        [(ngModel)]="parsedDefinition.pipeline.config.include_child_deals"
        (change)="onSaveReport()"
      >
        <span>Include child deals from portfolio</span>
      </mat-checkbox>
    </div>
    <div class="flex-row min-w-64 mt-5">
      <mat-checkbox
        [disabled]="!hasPermissionToEditForm"
        [color]="'primary'"
        [(ngModel)]="parsedDefinition.pipeline.config.include_deal_export"
        (change)="onSaveReport()"
      >
        <span>Include deal detail reports</span>
      </mat-checkbox>
    </div>
    @if (NewPermission.PDF_REPORTS_SHARING_RECORDS | hasPermission) {
      <div class="flex-row min-w-64 mt-5">
        <mat-checkbox
          [disabled]="!hasPermissionToEditForm"
          [color]="'primary'"
          [(ngModel)]="parsedDefinition.pipeline.config.show_dispositions"
          (change)="onSaveReport()"
        >
          <span>Include dispositions</span>
        </mat-checkbox>
      </div>
      <app-report-schedule-form [reportLayout]="reportLayout" (scheduleChanged)="scheduleChanged($event)">
      </app-report-schedule-form>
    }
  </div>
</div>
